
@if (iShowArticle) {
  <div style="border: solid">
    <div class="bg-light p-2 ps-5 mb-4 rounded" >
      <h5>LISTE DES ARTICLES
        @if (!readOnlyService.isReadOnly()) {
          <button type="button" class="ms-5 btn btn-success"
            (click)="onShowArticle()">
            AJOUTER
          </button>
        }
        <div class="form-check form-check-inline" style="margin-left: 20%">
          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" checked [(ngModel)]="showAllArticles"
            (change)="checkValue(showAllArticles)">
          <label class="form-check-label" for="inlineCheckbox1">Afficher tous les articles</label>
        </div>
      </h5>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">ARTICLE</th>
          <th scope="col">PRIX</th>
          <th scope="col">NB HEURES</th>
          <th scope="col">BOITE</th>
          <th scope="col">DESCRIPTION</th>
          <th scope="col">STATUT</th>
        </tr>
      </thead>
      <tbody>
        @for (a of iArticles; track a) {
          <tr>
            @if (a.active || showAllArticles) {
              <th scope="row">{{a.id}}</th>
            }
            @if (a.active || showAllArticles) {
              <td>{{a.name}}</td>
            }
            @if (a.active || showAllArticles) {
              <td>{{a.price}} €</td>
            }
            @if (a.active || showAllArticles) {
              <td>{{a.nbHours}}</td>
            }
            @if (a.active || showAllArticles) {
              <td>{{a.boxType}}</td>
            }
            @if (a.active || showAllArticles) {
              <td>{{a.description}}</td>
            }
            @if (a.active || showAllArticles) {
              <td>
                @if (a.active && !readOnlyService.isReadOnly()) {
                  <button type="button" class="btn btn-primary" (click)="activeArticle(a.id, true)">Activé</button>
                }
                @if (!a.active && !readOnlyService.isReadOnly()) {
                  <button type="button" class="btn btn-danger" (click)="activeArticle(a.id, false)">Désactivé</button>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}

<app-article-form (oArticleSaved)="onArticleSaved($event)"></app-article-form>
